export default __webpack_public_path__ + "static/media/(3).f855e0dc.jpeg";